/**
 * defa.views.ZoneView
 * A module-view for a Zone model.
 * @version 1.2.0
 */

import View        from 'scripts/poppet/view';
import template          from 'templates/zoneView.jst.html';
import { Vue }     from 'vue/defavue';
import vueTemplate from 'templates/zoneView.vue.html';
import { T }       from 'defa-object';


// !TODO: When we've externalized the url's, consider changing the nav-events on onClick open.
// think about this in tandem with view-control-settings-view.js as well.

const selectors = {
	region: '[data-region=zone-view-container]'
};

const ZoneView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template  : template,
	className : 'zone',
	noAnimate : true,  // views within control modules probably should animate themselves (xzibit-style)
	
	ui: {
		region: selectors.region
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	//
	
	
	onRender(){
		if('disabled' === this.model.getModel('5').get('zoneMode')){
			this.$el.addClass('isOff')
		}
	},
	
	/**
	 * Triggers when DOM has finished painting the element.
	 * @void
	 */
	onDomRefresh: function () {
		this.attachVueZoneView();
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Saves the OnOff attribute to backend
	 * @void
	 * !TODO implement this method in ControlView Poppet view
	 */
	saveModel: function (model, attrs) {
		let self = this;
		self.busy();
		try {
			self.model.getModel(model).save( attrs, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( 'onOff Model was saved!' );
					console.log( 'Fetching temperature models!' );
					self.idle();
				},
				error  : function () {
					console.error( 'onOff failed at saving...' );
					self.idle();
				}
			} );
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	},

	
	attachVueZoneView: function(){
		let self   = this;
		let region = this.ui.region[ 0 ];
		
		let Slider = new Vue ({
			template: vueTemplate,
			bb() {
				return {
					onOffModel: self.model.getModel('1'), // onOff
					heatingZoneModel: self.model.getModel('5'),
					thermostatModel: self.model.getModel('3'),
					settingsHomeModel: self.options.settingsHome,
					
				};
			},
			
			data() {
				return {
					onOffValue: 'OFF',
					locked  : !self.options.settingsHome.get('zone'+self.model.get('zoneNumber')).enabled,
				}
			},
			
			watch : {
				'onOffModel.onOff' : function (newValue){
					this.onOffValue = newValue ? 'ON' : 'OFF';
				}
			},
			
			computed: {
				disableZoneSwitch: function () {
					return null === this.onOffModel.onOff || null === this.heatingZoneModel.zoneMode
				},
				modelError: function () {
					return this.onOffModel.modelError
				},
				attributeError: function () {
					return this.onOffModel.onOffError
				},
				modeError: function () {
					return null === this.heatingZoneModel.zoneMode ? this.heatingZoneModel.modelError ||this.heatingZoneModel.zoneModeError : null;
				},
				
				
				/**
				 * Delegates creating the data for the radio strip based on the zone's mode.
				 * !TODO: Move these new strings introduced to the logic files out of the logic and into either templates or assets
				 * (defa.vars), let's keep the app logic free of strings.
				 * @returns {string}
				 */
				options() {
					let ret = '';
					
					switch ( this.heatingZoneModel.zoneMode ) {
						
						case 'thermostat' :
							ret = [
								{ value: 'ON', title: 'Comfort', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Saving', titleContext: 'ZoneView' }
							];
							break;
						
						case 'manual' :
							ret = [
								{ value: 'ON', title: 'On', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Off', titleContext: 'ZoneView' }
							];
							break;
						
						case 'regulator' :
							ret = [
								{ value: 'ON', title: 'Comfort', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Saving', titleContext: 'ZoneView' }
							];
							break;
						
						case 'disabled' :
							ret = false;
							break;
						
						default:
							ret = [
								{ value: 'ON', title: 'On', titleContext: 'ZoneView' },
								{ value: 'OFF', title: 'Off', titleContext: 'ZoneView' }
							];
					}
					
					return ret;
				},
				name() {
					return this.settingsHomeModel.get('zone'+self.model.get('zoneNumber')).zoneAlias ||T.tc('ZoneView', 'Zone') + ' ' + self.model.get('zoneNumber')
				},
				temperatureAlias() {
					return this.settingsHomeModel.get('zone'+self.model.get('zoneNumber')).temperatureAlias ||T.tc('ZoneView', 'Temperature') + ' ' + self.model.get('zoneNumber')
				},
				mode() {
					return this.heatingZoneModel.zoneMode !== null ? this.heatingZoneModel.zoneMode : '';
				},
				temperatureTarget() {
					return self.model.getTargetTemperature()
				},
				temperatureMeasured() {
					return this.thermostatModel.localTemperature !== null? this.thermostatModel.localTemperature  + '°': '-'
				},
				percentActive() {
					return self.model.getModel('4').get('currentLevel')
				},
				percentInactive() {
					return self.model.getModel('4').get('currentLevel')
				},
				hasThermostat() {
					return self.model.hasThermostat()
				}
			},
			
			methods : {
				save(newValue, attributeName) {
					let data = {};
					data[attributeName] = 'ON' === newValue;
					self.saveModel('1',  data )
				},
			},
			created () {
				this.onOffValue = this.onOffModel.onOff ? 'ON' : 'OFF';
			}
		});
		Slider.$mount( region );
		
	}
	
} );

export default ZoneView;
